import React from 'react'
import HowWeAre from '../../../react4xp/components/HowWeAre'

function HowWeArePart({bgColor, tag, title, intro, contentBlocks}) {
	return (
		<HowWeAre
			bgColor={bgColor}
			tag={tag}
			title={title}
			intro={intro}
			contentBlock={contentBlocks?.map(contentBlock => ({
				img: contentBlock.imageSrc?.link && {
					srcSmall: contentBlock.imageSrcSmall?.link,
					srcMedium: contentBlock.imageSrcMedium?.link,
					src: contentBlock.imageSrc.link,
					alt: contentBlock.imageSrc.alt,
				},
				title: contentBlock.text
			}))}
		/>
	)
}

export default (props) => <HowWeArePart {...props} />
